<template>
  <div>
    <b-select
      v-model="signVariant"
      :items="signVariantList"
      label="Тип сервісу">
      <template #item="{ item, props }">
        <v-list-item v-bind="props" :prepend-icon="item.raw.icon"></v-list-item>
      </template>
      <template #selection="{ item }">
        <v-icon class="mr-3">{{ item.raw.icon }}</v-icon>
        <span>{{ item.title }}</span>
      </template>
    </b-select>
    <div v-if="signVariant === 'diia'">
      <div class="text-center mx-auto mb-5" style="max-width: 450px">
        Для підписання за допомогою Дія.Підпису Вам потрібно встановити
        мобільний застосунок Дія.
      </div>

      <div>
        <v-btn
          class="mb-2"
          block
          rounded="pill"
          :loading="$loading.isLoading('sendSign')"
          @click="signDiia">
          Затвердити і підписати
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { inject, ref } from 'vue'
import { openDialog } from '@/dialog'
import { dialogKey, fileToSignKey } from '../injectionKeys'

export default {
  name: 'SignCloud',
  emits: ['cancel'],
  setup() {
    const dialog = inject(dialogKey)!
    const fileToSign = inject(fileToSignKey)

    const signVariant = ref<'diia'>('diia')
    const signVariantList = [
      {
        id: 'diia',
        name: 'Дія.Підпис',
        icon: 'best:diia',
      },
    ]

    const signDiia = () => {
      return openDialog({
        name: 'SignDiia',
        params: {
          hideActionButtons: true,
          cb: res => dialog.submit(res),
        },
        dialogData: {
          diiaRequest: dialog.dialogData.diiaRequest,
          document: fileToSign?.value[0].document,
          fileToSign: fileToSign?.value[0].file,
        },
      })
    }

    return { signVariant, signVariantList, signDiia }
  },
}
</script>

<style scoped lang="scss"></style>
